import { inputBatchApi } from "../features/inputBatches/inputBatchApi";
import { configureStore } from "@reduxjs/toolkit";
import { authApi } from "../features/auth/authApi";
import { batchApi } from "../features/batches/batchApi";
import { itemApi } from "../features/items/itemApi";
import { itemRoutingApi } from "../features/itemRoutings/itemRoutingApi";
import { lineApi } from "../features/lines/lineApi";
import { machineCapabilityApi } from "../features/machineCapabilities/machineCapabilityApi";
import { machineApi } from "../features/machines/machineApi";
import { oemApi } from "../features/oems/oemApi";
import { operationApi } from "../features/operations/operationApi";
import { pageApi } from "../features/pages/pageApi";
import { plantApi } from "../features/plants/plantApi";
import { processApi } from "../features/processes/processApi";
import { qrApi } from "../features/qr/qrApi";
import { rawMaterialApi } from "../features/rawMaterials/rawMaterialApi";
import { roleApi } from "../features/roles/roleApi";
import { relationTypeApi } from "../features/relationTypes/relationTypeApi";
import { settingsApi } from "../features/settings/settingsApi";
import { shiftApi } from "../features/shifts/shiftApi";

export const store = configureStore({
  reducer: {
    [inputBatchApi.reducerPath]: inputBatchApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [batchApi.reducerPath]: batchApi.reducer,
    [itemApi.reducerPath]: itemApi.reducer,
    [itemRoutingApi.reducerPath]: itemRoutingApi.reducer,
    [lineApi.reducerPath]: lineApi.reducer,
    [machineCapabilityApi.reducerPath]: machineCapabilityApi.reducer,
    [machineApi.reducerPath]: machineApi.reducer,
    [oemApi.reducerPath]: oemApi.reducer,
    [operationApi.reducerPath]: operationApi.reducer,
    [pageApi.reducerPath]: pageApi.reducer,
    [plantApi.reducerPath]: plantApi.reducer,
    [processApi.reducerPath]: processApi.reducer,
    [qrApi.reducerPath]: qrApi.reducer,
    [rawMaterialApi.reducerPath]: rawMaterialApi.reducer,
    [roleApi.reducerPath]: roleApi.reducer,
    [relationTypeApi.reducerPath]: relationTypeApi.reducer,
    [settingsApi.reducerPath]: settingsApi.reducer,
    [shiftApi.reducerPath]: shiftApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(authApi.middleware)
      .concat(batchApi.middleware)
      .concat(inputBatchApi.middleware)
      .concat(itemApi.middleware)
      .concat(itemRoutingApi.middleware)
      .concat(lineApi.middleware)
      .concat(machineCapabilityApi.middleware)
      .concat(machineApi.middleware)
      .concat(oemApi.middleware)
      .concat(operationApi.middleware)
      .concat(pageApi.middleware)
      .concat(plantApi.middleware)
      .concat(processApi.middleware)
      .concat(qrApi.middleware)
      .concat(rawMaterialApi.middleware)
      .concat(roleApi.middleware)
      .concat(relationTypeApi.middleware)
      .concat(settingsApi.middleware)
      .concat(shiftApi.middleware),
});
